import React from 'react';

export default function VideoReels({ videoReels }) {
  const all = videoReels.filter(v => v.videoId)
    .sort((a, b) => new Date(b.publishedAt || 0) - new Date(a.publishedAt || 0));
  if (all.length === 0) return null;

  const videos = [];
  const srcCount = {};
  const used = new Set();
  // Round-robin: one per unseen source first
  for (const v of all) {
    if (videos.length >= 12) break;
    const src = v.source || 'unknown';
    if (!srcCount[src]) { videos.push(v); used.add(v); srcCount[src] = 1; }
  }
  // Fill remaining slots, max 2 per source
  for (const v of all) {
    if (videos.length >= 12) break;
    if (used.has(v)) continue;
    const src = v.source || 'unknown';
    if ((srcCount[src] || 0) < 2) { videos.push(v); srcCount[src] = (srcCount[src] || 0) + 1; }
  }
  return (
    <section style={{ marginTop: 28 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
        <span style={{ fontSize: 13, fontFamily: "JetBrains Mono", fontWeight: 700, color: "var(--bs-ink, #fff)", letterSpacing: 1.5 }}>🔥 TRENDING CLIPS</span>
      </div>
      <div style={{ display: "flex", gap: 10, overflowX: "auto", paddingBottom: 8 }}>
        {videos.map((video, i) => (
          <a key={video.videoId || i} href={video.url} target="_blank" rel="noopener noreferrer"
            style={{ flexShrink: 0, width: 180, textDecoration: "none", color: "inherit" }}>
            <div style={{ position: "relative", borderRadius: 8, overflow: "hidden", marginBottom: 6 }}>
              <img src={`https://img.youtube.com/vi/${video.videoId}/mqdefault.jpg`} alt={video.title}
                style={{ width: "100%", height: 100, objectFit: "cover", display: "block" }} />
              <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", background: "#0004" }}>
                <span style={{ fontSize: 24, color: "#fff", textShadow: "0 2px 8px #000" }}>▶</span>
              </div>
            </div>
            <p style={{ fontSize: 11, color: "var(--bs-body, #ccc)", lineHeight: 1.3, overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>{video.title}</p>
            <p style={{ fontSize: 9, color: "var(--bs-body, #555)", marginTop: 2 }}>{video.source}</p>
          </a>
        ))}
      </div>
    </section>
  );
}
